import common from './index.json'

const requireLang = require.context(
  './',
  true,
  /\.json$/
)

const messages = {
  ...common
}

for (const file of requireLang.keys()) {
  if (file === './index.js' || file === './index.json') continue
  const path = file.replace(/(\.\/|\.json$)/g, '').split('/')
  path.reduce((o, s, i) => {
    const prop = s

    o[prop] = i + 1 === path.length
      ? requireLang(file)
      : o[prop] || {}

    return o[prop]
  }, messages)
}

export default messages
